export class ItemDescontoProducao{
    Id: number = 0;
    EntradaProducaoId: number;
    TipoDescontoProducaoId: number;
    TipoDescontoNome:string = "";
    Percentual: number = 0;
    Quantidade: number = 0;
    Observacao:string = "";
}
